const e = [
  { value: "M", label: "general.gender.M" },
  { value: "F", label: "general.gender.F" }
];
export {
  e as genders
};
